import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TagService } from "../../services/tag.service";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-tags",
  templateUrl: "./tags.component.html",
  styleUrls: ["./tags.component.scss"],
})
export class TagsComponent implements OnInit {
  tags: any = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private graphqlService: TagService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }
  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      console.log("Tags", result);
      if (result && result.data) {
        this.tags = result.data["tags"].edges.map((edge) => edge.node);
        this.count = result.data["tags"].totalCount;
        this.pageCursors[this.pageIndex] = result.data["tags"].pageInfo;
      }
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/tags/tags.component.ts